import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import './App.css';

import Config from './../config/Config';
import Session from './../Session';
import Utils from './../Utils';

import TopBar from '../../common/components/topBar/TopBar';
import Footer from '../../common/components/footer/Footer';

//Pages
import Documentation from '../../common/containers/documentation/Documentation';
import ControlPanel from '../../common/containers/controlPanel/ControlPanel';
import Management from '../../common/containers/management/Management';
import Feedback from '../../common/containers/feedback/Feedback';
import ErrorPage from '../../common/containers/errorPage/ErrorPage';

class App extends Component {
  constructor(props) {
    super(props);
    
    Session.start();
    Session.setCallback(() => this.checkLogin());
    
    this.state = {session: Session.getParams()};
  }
  
  render() {
    var isLoggedIn = this.state.session.isLoggedIn;
    var hasAPIAccess = this.state.session.hasAPIAccess;
    
    return <Router basename={Config.base}>
    <div className="App">
    <TopBar />
    <div className="Page">
    <Switch>
    <Route path="/documentation" component={Documentation} />
    {
      (isLoggedIn) ? 
      (hasAPIAccess) ?
      <Switch>
      <Route path="/control-panel" component={ControlPanel} />
      <Route path="/management" component={Management} />
      <Route path="/feedback" component={Feedback} />
      </Switch>
      : 
      <Route path="/(control-panel|management|feedback)/" render={() => {
        return <ErrorPage title="Access Denied" 
        description="Seems like your account doesn't have access to the Swonkie API." 
        buttonText="Apply for access" buttonTo={Config.mainHost}/>;
      }} />
      : 
      <Route path="/(control-panel|management|feedback)/" render={() => {
        return <ErrorPage title="Login Required" 
        description="In order to use this page you need to be logged in." 
        buttonText="Login Now" buttonClick={() => Utils.reloadPage(Utils.getLoginUrl()) }/>;
      }} />
    }
    <Redirect exact from="/" to="/documentation" />
    <Route render={() => {
      return <ErrorPage title="404" description="Ups! This page doesn't exist yet."
      buttonText="Get Back to Documentation" buttonTo="/documentation"/>;
    }} />
    </Switch>
    <Footer />
    </div>
    </div>
    </Router>;
  }
  
  checkLogin() {
    this.setState({
      session: Session.getParams()
    });
  }
}

export default App;
